import { CheckboxModel } from '../core/models/checkbox.model';
import { InputModel } from '../core/models/input.model';
import { RadioPointModel } from '../core/models/radio-point.model';
import { SelectModel } from '../core/models/select.model';
import { TableRow } from '../core/models/table-row.model';
import { Numbers } from './constants';
import { setInputModel, setCheckboxModel, setRadioPointModel, setSelectModel, setSelectOptions } from './labels.utils';

export const commonLegalDomiciliation = (linkFormPath: string) => {
    return {
        // IBAN
        iban: new InputModel( setInputModel([linkFormPath, 'domiciliation', 'iban'], 'form.domiciliacion.iban',
        {requiredText: 'form1.default-error'}, true)),
        // SWIFT
        swift: new InputModel( setInputModel([linkFormPath, 'domiciliation', 'swift'], 'form.domiciliacion.swift',
        { requiredText: 'form1.default-error'})),
        // Acept terms checkbox
        acceptTerms: new CheckboxModel(
        setCheckboxModel([linkFormPath, 'domiciliation', 'acceptTerms'],
            'legal.domiciliacion.acceptTerms', false, 'form1.default-error')),
        // adequacyOfProduct
        adequacyOfProduct: new CheckboxModel(setCheckboxModel([linkFormPath, 'domiciliation', 'adequacyOfProduct'], 'legal.domiciliacion.adequacyOfProduct', true, 'form3.default-error')),
        // // treatment of data
        /* treatmentOfData: new RadioPointModel({
          linkFormPath: [linkFormPath, 'termsList'],
          id: '1',
          description: 'form3.emergencyContact.treatmentOfData',
          optionTwoSelectedSubText: 'form3.emergencyContact.treatmentOfDataConsent',
          optionOneText: 'form3.emergencyContact.yes',
          optiontwoText: 'form3.emergencyContact.no',
          checked: true
        }), */
        treatmentOfData: new RadioPointModel(setRadioPointModel([linkFormPath, 'termsList'], '1',
          {
            description: 'legal.domiciliacion.treatmentOfData',
            optionTwoSelectedSubText: 'legal.domiciliacion.treatmentOfDataConsent',
            optionOneText: 'form3.emergencyContact.yes',
            optiontwoText: 'form3.emergencyContact.no'
          }, true)),
        // advertaising international isos
        sendAdvertisingInternationalSOS: new RadioPointModel(setRadioPointModel( [linkFormPath, 'termsList'] , '15',
          {
            description: 'legal.domiciliacion.sendAdvertisingInternationalSOS',
            optionOneText: 'form3.emergencyContact.yes',
            optiontwoText: 'form3.emergencyContact.no'
          }, false)),
        // sendAdvertisingByThirdParties
        sendAdvertisingByThirdParties: new RadioPointModel(setRadioPointModel([linkFormPath, 'termsList'] , '9',
          {
            description: `legal.domiciliacion.sendAdvertisingByThirdParties`,
            optionOneText: 'form3.emergencyContact.yes',
            optiontwoText: 'form3.emergencyContact.no'
          }, false)),
        // sendAdvertisingEventsAndNews
        sendAdvertisingEventsAndNews: new RadioPointModel(setRadioPointModel([linkFormPath, 'termsList'], '16',
          {
            description: `legal.domiciliacion.sendAdvertisingEventsAndNews`,
            optionOneText: 'form3.emergencyContact.yes',
            optiontwoText: 'form3.emergencyContact.no'
          }, false))

    };
};

export const guaranteeSelectionLegal = (linkFormPath: string) => {
    return {
        linkFormPath: [linkFormPath, 'guaranteeSelection'],
        title: 'Seleccion de garantías',
        headerRows: {
            guarantee: 'Garantía',
            limit: 'Límite',
            extendGuarantee: 'Ampliar Límite',
            included: 'Incluido'
        },
        rows: [fillRowsData( linkFormPath, 'deathAndDisability', 'Fallecimiento e invalidez', '10.000€'),
            fillRowsData( linkFormPath, 'tripCancellation', 'Anulación de viaje', '1.000€'),
            fillRowsData( linkFormPath, 'lostOrStolenLuggage', 'Perdida o robo de equipajes', '600€'),
            fillRowsData( linkFormPath, 'vacationRefund', 'Reembolso de vacaciones', '1.000€')
        ]
    };
};


/**
 * fillRowsData
 * @param type string
 * @param guaranteeData string
 * @param limitData string
 * @returns TableRow
 */
function fillRowsData(linkFormPath: string, type: string, guaranteeData: string, limitData: string): TableRow {
    return new TableRow({
      linkFormPath: [linkFormPath, 'guaranteeSelection', type],
      guarantee: guaranteeData,
      limit: limitData,
      extendGuarantee: new SelectModel(
        setSelectModel([linkFormPath, 'guaranteeSelection', type], {},
        setSelectOptions('', '', [{ name: '0 €', id: -1 },
          { name: '20.000 €', id: Numbers.number0 }, { name: '30.000 €', id: Numbers.number1 }])
      )),
      included: {
        yes: {
          classNameIcon: 'icon-ok'
        },
        no: {
          classNameIcon: 'icon-error'
        }
      }
    });
}
